import React from 'react';
import { ADGMResponsiveModal, Loading } from 'aurora-components';
import ADGMPanelInputsGeneratorBody from 'aurora-components/ADGMPanelInputsGenerator/ADGMPanelInputsGeneratorBody';
import { keyEmptyCheck } from 'aurora-utils/utils';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withStyles, Button } from '@material-ui/core';
import styles from './styles';

const AddConditionModal = ({
  openModal,
  loading,
  selectedCondition,
  toggleModal,
  classes,
  sectionFields,
  handleSubmit,
}) => {
  return (
    <ADGMResponsiveModal
      classes={{
        modalTitleHead: classes.modalTitleHead,
        crossIconBtn: classes.crossIconBtn,
      }}
      customClasses={{
        modal: classes.modalModified,
        content: classes.modalModifiedContent,
      }}
      open={openModal}
      toggleModal={toggleModal}
      onClose={toggleModal}
      title={selectedCondition.index !== undefined ? keyEmptyCheck('edit_a_term') : keyEmptyCheck('add_term')}
    >
      <div className={classes.modalContainer}>
        {loading && <Loading />}
        <ADGMPanelInputsGeneratorBody
          isEditable
          title=''
          sections={sectionFields}
          isModal
          classes={{
            containerPadding: classes.modalContainerModified,
            sectionTitle: classes.modalSectionTittle,
            titleWrapper: classes.modalTitleWrapper,
          }}
        />
        <div className={classes.buttonSection}>
          <Button onClick={toggleModal} className={classes.cancelButton}>
            {keyEmptyCheck('cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            disabled={!selectedCondition.appendixEn || !selectedCondition.appendixAr}
            className={classes.submitButton}
            onClick={handleSubmit}
          >
            {selectedCondition.index !== undefined ? keyEmptyCheck('save') : keyEmptyCheck('add_term')}
          </Button>
        </div>
      </div>
    </ADGMResponsiveModal>
  );
};
AddConditionModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  sectionFields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  selectedCondition: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
export default withStyles(styles)(injectIntl(AddConditionModal));
